import React from 'react';
import noImage from '../../image/no_image.png'

const ImageArea = (props) => {
    const src = (props.src !== "") ? props.src : noImage;
    return (
        <div className="p-input__image">
            <img src={src} alt={"Image of the question"} />
        </div>
    )
};

export default ImageArea